import { render } from "./StandardDefinition.vue.js?vue&type=template&id=0fd470e0!=!../vue-loader/dist/index.js??ruleSet[0]!./StandardDefinition.vue?vue&type=template&id=0fd470e0"
import script from "./StandardDefinition.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./StandardDefinition.vue?vue&type=script&lang=js"
export * from "./StandardDefinition.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./StandardDefinition.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__